/* Raindoor Design System v1.0 — "Nuestros #virales" (app TikTok Feed de Reputon).
   La app avanza un slide cada 5 s. Aquí lo convertimos en un desplazamiento continuo y lineal,
   como la guincha de bancos. Solo se tocan los parámetros de su Swiper, no la app. */
(function () {
  var SPEED_MS = 4500; // tiempo por tarjeta
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function setup(el) {
    var sw = el.swiper;
    if (!sw || sw.__rdMarquee || !sw.params || !sw.autoplay) return;
    sw.__rdMarquee = true;

    sw.params.speed = SPEED_MS;
    sw.params.autoplay = Object.assign(sw.params.autoplay || {}, {
      delay: 0,
      disableOnInteraction: false,
      waitForTransition: true,
      pauseOnMouseEnter: false,
    });
    sw.autoplay.stop();
    sw.autoplay.start();

    // Pausa al pasar el mouse para poder abrir un video; retoma al salir.
    el.addEventListener('mouseenter', function () {
      sw.autoplay.stop();
      sw.setTransition(0);
      sw.setTranslate(sw.getTranslate());
    });
    el.addEventListener('mouseleave', function () {
      sw.autoplay.start();
    });
  }

  function scan() {
    document.querySelectorAll('.reputon-tiktok-widget .swiper, .reputon-tiktok-widget .swiper-container').forEach(setup);
  }

  // La app monta su carrusel de forma asíncrona y a veces lo vuelve a crear.
  var tries = 0;
  var timer = setInterval(function () {
    scan();
    if (++tries > 60) clearInterval(timer);
  }, 1000);
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
